import { useState } from 'react';
import { items } from '../../collectionsData';
import ItemCard from '../../components/ItemCard/ItemCard';

const Member = () => {

    const [active, setActive] = useState(['active', '', '', '', '']);

    const changeActive = (index) => {
        let temparr = ['', '', '', '', ''];
        temparr[index] = 'active';
        setActive(temparr);
    }

    return(
        <div className="bg-[white] dark:bg-dark-content-bg dark:text-white transition-colors duration-300 ease-in-out">
            
            <div className="h-[20vh] bg-gray-200 dark:bg-[#00021a]">
            </div>

            <div className="max-w-[1600px] mx-auto px-[5vw] md:px-10 ">

                <div className="flex justify-center w-full">
                    <div className="w-full max-w-[70px] sm:max-w-[100px] lg:max-w-[150px] 2xl:max-w-[200px] relative -top-[35px] md:-top-[50px] lg:-top-[75px] 2xl:-top-[100px] -mb-[35px] md:-mb-[50px] lg:-mb-[75px] 2xl:-mb-[100px]">
                        <img src = 'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80' 
                        alt = 'collectionimage' className = 'w-full h-full object-cover rounded-full'/>
                    </div>
                </div>

                <div className="flex flex-col w-full items-center my-10">
                    <h1 className='text-lg lg:text-2xl 2xl:text-3xl font-bold mb-3'>ReddingTon 666</h1>
                    <p className='text-base lg:text-lg text-gray-500 dark:text-slate-500'>
                        4x023230230
                    </p>
                    <p className='text-base lg:text-lg text-gray-500 dark:text-slate-500 mb-3'>
                        Joined Februray 2020
                    </p>
                    <div className='flex'>
                        <a href = '/' target='_blank' className="mr-2 w-[30px] h-[25px] mb-2">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 640 512">
                                <path d="M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"/>
                            </svg>
                        </a>
                        <a href = '/' target='_blank' className="w-[25px] h-[25px] mb-2">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 496 512">
                                <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"/>
                            </svg>
                        </a>
                    </div>
                </div>

                <div className='flex flex-col lg:flex-row justify-center items-center'>
                    <div className="flex mb-4 justify-center flex-wrap">
                        <button className={`w-[110px] py-2 px-2 font-bold text-base lg:text-lg ${active[0] === 'active' && 'border-b-[2px] border-main'}`} onClick = {() => changeActive(0)}>Collected</button>
                        <button className={`w-[110px] py-2 px-3 font-bold text-base lg:text-lg ${active[1] === 'active' && 'border-b-[2px] border-main'}`} onClick = {() => changeActive(1)}>Created</button>
                        <button className={`w-[110px] py-2 px-3 font-bold text-base lg:text-lg ${active[2] === 'active' && 'border-b-[2px] border-main'}`} onClick = {() => changeActive(2)}>Favorited</button>
                        <button className={`w-[110px] py-2 px-3 font-bold text-base lg:text-lg ${active[3] === 'active' && 'border-b-[2px] border-main'}`} onClick = {() => changeActive(3)}>Hidden</button>
                        <button className={`w-[110px] py-2 px-3 font-bold text-base lg:text-lg ${active[4] === 'active' && 'border-b-[2px] border-main'}`} onClick = {() => changeActive(4)}>Activity</button>   
                    </div>

                    <div className='flex mb-4 '>
                        <select className='w-[110px] mx-3 py-2 member_select font-bold text-base lg:text-lg mr-4'>
                            <option value=''>Offers</option>
                        </select>
                        <select className='w-[110px] py-2 member_select font-bold text-base lg:text-lg'>
                            <option value=''>Listings</option>
                        </select>
                    </div>
                </div>

                <div className='flex w-full flex-col lg:flex-row justify-center items-center'>
                    <div className='searchbar flex-grow w-full max-w-[500px] lg:max-w-full'>
                        <input type='search' className='main_placeholder mb-4 lg:mb-0  text-white w-full py-3 px-3 font-bold text-base bg-gray-400 dark:bg-gray-700 rounded-[7px]' placeholder='Search'/>
                    </div>
                    <div className='flex'>
                        <select className='w-[220px] mx-2 memeber_select_2 bg-gray-400 dark:bg-gray-700 rounded-[7px] text-white py-2 text-base lg:text-lg'>
                            <option value=''>Single Items</option>
                        </select>
                        <select className='w-[220px] memeber_select_2 bg-gray-400 dark:bg-gray-700 rounded-[7px] text-white py-2 text-base lg:text-lg'>
                            <option value=''>Recently Recieved</option>
                        </select>
                    </div>
                </div>


                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 2xl:grid-cols-6 gap-6 my-20">
                    {items.map((item, index) => {
                        if(index < 8){
                            return(
                                <ItemCard item = {item} key = {index}/>
                            )
                        }
                        else return null;
                    })}
                </div>


            </div>
        </div>
    )   
}

export default Member;